import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import LazyBackgroundImage from '../../Common/LazyBackgroundImage';

import { PaddedLandingPageComponent } from '../../../styling/layout-containers/LandingPageContainers';
import { mediumWeight } from '../../../styling/mixins/typography';
import {
  DESKTOP_START_QUERY,
  DESKTOP_MEDIUM_START_QUERY,
} from '../../../styling/mixins/responsive';

import HandOffLink from '../../../utils/urls/HandOffLink';

const Container = styled(PaddedLandingPageComponent)`
  display: flex;
  flex-flow: row wrap;
  margin: 0px;

  @media (${DESKTOP_START_QUERY}) {
    flex-flow: row;
  }

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    margin: 0 -16px;
  }
`;

const TileWrapper = styled(HandOffLink)`
  display: block;
  padding: 6px;
  width: 50%;
`;

const TileLabel = styled.div`
  ${mediumWeight};
  font-size: 14px;
  left: 10px;
  line-height: 16px;
  position: absolute;
  text-align: left;
  top: 12px;
  width: 60%;
`;

const Tile = styled(LazyBackgroundImage)`
  background-size: cover;
  border-radius: 5px;
  color: lapel;
  padding-top: calc(88 / 165 * 100%);
  position: relative;
  width: 100%;
`;

class FlyerTile extends Component {
  static propTypes = {
    href: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };

  render() {
    const { href, image, name } = this.props;
    const tracking = { identifier: name };

    return (
      <TileWrapper href={href} tracking={tracking}>
        <Tile backgroundImage={image}>
          <TileLabel>{name}</TileLabel>
        </Tile>
      </TileWrapper>
    );
  }
}

class FlyerCategoryTiles extends Component {
  static propTypes = {
    className: PropTypes.string,
    tiles: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ),
  };

  render() {
    const { className, tiles } = this.props;

    return (
      <Container className={className}>
        {tiles.map((tile, i) => (
          <FlyerTile key={i} {...tile} />
        ))}
      </Container>
    );
  }
}

export default FlyerCategoryTiles;
